export default {
  LAW: [
    'Antitrust Law',
    'Appellate Law',
    'Arbitration & Mediation',
    'Banking & Financial',
    'Bankrupty & Workout',
    'Business Law',
    'Civil Trial',
    'Commercial Litigation',
    'Construction',
    'Consumer Debt',
    'Criminal Defense',
    'DUI / DWI',
    'Eminent Domain',
    'Family Law',
    'General Practice',
    'Government & Administrative',
    'Health Care Law',
    'Immigration Law',
    'Intellectual Property Rights',
    'Insurance',
    'International Law',
    'Labor & Employment',
    'Land Use & Environment',
    'Real Estate',
    'Social Security / Elder Law',
    'Traffic Law',
    'Wills, Trusts, & Estates',
    'Worker\'s Compensation',
  ],
};
